export default __webpack_public_path__ + "static/media/c.6c43abc2.svg";